module.exports = __webpack_public_path__ + "media/images/icon-benefits-life-06cb23c2d4218c0c0ae20bf4c3ce4cf3.png";